import { forceInt, getConfig } from "../helpers"

const PaginationMixin = {
    computed: {
        shouldRenderPagination() {
            return _.get(this.meta, 'last_page', 1) > 1
        },
    },
    data() {
        return {
            meta: null,
        }
    },
	methods: {
        rowIndex(index, query = {}) {
            let calculatedIndex = forceInt(index) + 1
            const currentPage = forceInt(query.page || 1),
                perPage = forceInt(query.limit || getConfig('pagination', 10))
            return (currentPage - 1) * perPage + calculatedIndex
        },
        setMeta(response) {
            this.meta = _.get(response, 'data.meta', null)
        },
	},
}

export default PaginationMixin
